import * as R from 'ramda';


export default function BulkDeleteArchivedReportInstancesDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  loaderService,
  ssDialogService,
  bulkDeleteArchivedReportInstancesConfirmDialog
) {
  const vm = this;
  
  vm.deleteIsSelected = false;
  vm.hasData = true;

  vm.deletableReportInstances;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkDelete = _handleBulkDelete;
  vm.handleSelectAll = _handleSelectAll;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    _populateDeletableReportInstances();

    $scope.$on('selectBulkReportInstanceArchiveChange', () => {
      _handleSelectReportInstanceChange();
    });
  }

  function _handleBulkDelete($event) {
    const _ids = [];

    R.forEach((reportInstance) => {
      if (reportInstance.isBulkDelete) {
        _ids.push(reportInstance.reportInstanceArchiveId);
      }
    }, vm.reportInstances);

    ssDialogService.dialogs.reports.bulkDeleteArchivedReportInstancesConfirmDialog = ssDialogService.alert(
      bulkDeleteArchivedReportInstancesConfirmDialog.getOptions($event, {
        reportTypeId: vm.reportType.uniqueId,
        archivedReportInstanceIds: _ids,
        updateCallBack: _broadcastEvents,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.bulkDeleteArchivedReportInstancesConfirmDialog);
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.bulkDeleteArchivedReportInstancesDialog);
  }

  function _handleSelectAll() {
    R.forEach((reportInstance) => {
      reportInstance.isBulkDelete = vm.selectAll;
      vm.deleteIsSelected = vm.selectAll;
    }, vm.deletableReportInstances);
  }

  function _handleSelectReportInstanceChange() {
    const selectedIds = [];
    R.forEach((item) => {
      if (item.isBulkDelete === true) {
        selectedIds.push(item.reportInstanceArchiveId);
      }
    }, vm.reportInstances);
    vm.deleteIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.reportInstances.length;
  }

  function _populateDeletableReportInstances() {
    vm.deletableReportInstances = [];

    R.forEach((reportInstance) => {
      if (reportInstance.isMyReport === true) {
        vm.deletableReportInstances.push(reportInstance);
      }
    }, vm.reportInstances);
  }


  /** ************************************************
   * Private Functions
   */
  function _broadcastEvents() {
    // $rootScope.$broadcast('refreshArchivedReportInstances', { reportType: vm.reportType });
  }
}

BulkDeleteArchivedReportInstancesDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'loaderService',
  'ssDialogService',
  'bulkDeleteArchivedReportInstancesConfirmDialog',
];
